import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { DOM } from '@antv/l7-utils';
import Control from "./control";
export { ButtonControl };

var ButtonControl = /*#__PURE__*/function (_Control) {
  _inherits(ButtonControl, _Control);

  var _super = _createSuper(ButtonControl);

  function ButtonControl() {
    var _this;

    _classCallCheck(this, ButtonControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isDisable", false);

    return _this;
  }

  _createClass(ButtonControl, [{
    key: "setIsDisable",
    value:
    /**
     * 设置当前按钮
     * @param newIsDisable
     */
    function setIsDisable(newIsDisable) {
      this.isDisable = newIsDisable;

      if (newIsDisable) {
        var _this$button;

        (_this$button = this.button) === null || _this$button === void 0 ? void 0 : _this$button.setAttribute('disabled', 'true');
      } else {
        var _this$button2;

        (_this$button2 = this.button) === null || _this$button2 === void 0 ? void 0 : _this$button2.removeAttribute('disabled');
      }
    }
  }, {
    key: "createButton",
    value: function createButton() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return DOM.create('button', "l7-button-control ".concat(className));
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      this.button = this.createButton();
      this.isDisable = false;
      var _this$controlOption = this.controlOption,
          title = _this$controlOption.title,
          btnText = _this$controlOption.btnText,
          btnIcon = _this$controlOption.btnIcon;
      this.setBtnTitle(title);
      this.setBtnText(btnText);
      this.setBtnIcon(btnIcon);
      return this.button;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      this.button = this.buttonIcon = this.buttonText = undefined;
      this.isDisable = false;
    }
    /**
     * 更新配置方法
     * @param newOptions
     */

  }, {
    key: "setOptions",
    value: function setOptions(newOptions) {
      var title = newOptions.title,
          btnText = newOptions.btnText,
          btnIcon = newOptions.btnIcon;

      if (this.checkUpdateOption(newOptions, ['title'])) {
        this.setBtnTitle(title);
      }

      if (this.checkUpdateOption(newOptions, ['btnIcon'])) {
        this.setBtnIcon(btnIcon);
      }

      if (this.checkUpdateOption(newOptions, ['btnText'])) {
        this.setBtnText(btnText);
      }

      _get(_getPrototypeOf(ButtonControl.prototype), "setOptions", this).call(this, newOptions);
    }
    /**
     * 设置按钮 title
     * @param title
     */

  }, {
    key: "setBtnTitle",
    value: function setBtnTitle(title) {
      var _this$button3;

      (_this$button3 = this.button) === null || _this$button3 === void 0 ? void 0 : _this$button3.setAttribute('title', title !== null && title !== void 0 ? title : '');
    }
    /**
     * 设置按钮 Icon
     * @param newIcon
     */

  }, {
    key: "setBtnIcon",
    value: function setBtnIcon(newIcon) {
      if (this.buttonIcon) {
        DOM.remove(this.buttonIcon);
      }

      if (newIcon) {
        var _this$button4;

        var firstChild = (_this$button4 = this.button) === null || _this$button4 === void 0 ? void 0 : _this$button4.firstChild;

        if (firstChild) {
          var _this$button5;

          (_this$button5 = this.button) === null || _this$button5 === void 0 ? void 0 : _this$button5.insertBefore(newIcon, firstChild);
        } else {
          var _this$button6;

          (_this$button6 = this.button) === null || _this$button6 === void 0 ? void 0 : _this$button6.appendChild(newIcon);
        }

        this.buttonIcon = newIcon;
      }
    }
    /**
     * 设置按钮文本
     * @param newText
     */

  }, {
    key: "setBtnText",
    value: function setBtnText(newText) {
      if (!this.button) {
        return;
      }

      DOM.removeClass(this.button, 'l7-button-control--row');
      DOM.removeClass(this.button, 'l7-button-control--column');

      if (newText) {
        var btnText = this.buttonText;

        if (!btnText) {
          var _this$button7;

          btnText = DOM.create('div', 'l7-button-control__text');
          (_this$button7 = this.button) === null || _this$button7 === void 0 ? void 0 : _this$button7.appendChild(btnText);
          this.buttonText = btnText;
        }

        btnText.innerText = newText;
        DOM.addClass(this.button, this.controlOption.vertical ? 'l7-button-control--column' : 'l7-button-control--row');
      } else if (!newText && this.buttonText) {
        DOM.remove(this.buttonText);
        this.buttonText = undefined;
      }
    }
  }]);

  return ButtonControl;
}(Control);

export { ButtonControl as default };